module.exports = __webpack_public_path__ + "static/media/home-slide3.0092d225.webp";